import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  ChevronRight, 
  ShoppingCart, 
  Check, 
  Leaf, 
  Droplet, 
  ChevronDown,
  ChevronUp,
  Package,
  Award,
  Clock,
  Gift,
  X,
  ChevronLeft,
  ZoomIn
} from 'lucide-react';
import { useCart } from '../context/CartContext';
import cup110_1 from '../assets/images/cup110_1.jpg';
import cup110_2 from '../assets/images/cup110_2.jpg';
import cup110_3 from '../assets/images/cup110_3.jpg';
import cup110_4 from '../assets/images/cup110_4.jpg';
import cup110_label from '../assets/images/cup110_label.jpg';
import cup110_nutrition from '../assets/images/cup110_nutrition.png';
import cupffee_110ml from '../assets/images/cupffee_110ml.jpg';

const EdibleCup110 = () => {
  const [selectedQuantity, setSelectedQuantity] = useState('10');
  const [activeTab, setActiveTab] = useState('description');
  const [selectedImage, setSelectedImage] = useState(0);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [isQuantityDropdownOpen, setIsQuantityDropdownOpen] = useState(false);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [lightboxImageIndex, setLightboxImageIndex] = useState(0);
  const [isAddedToCart, setIsAddedToCart] = useState(false);
  
  const { addToCart } = useCart();

  // Handle keyboard navigation in lightbox
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isLightboxOpen) return;
      
      if (e.key === 'Escape') {
        setIsLightboxOpen(false);
      } else if (e.key === 'ArrowRight') {
        setLightboxImageIndex((prev) => (prev + 1) % productImages.length);
      } else if (e.key === 'ArrowLeft') {
        setLightboxImageIndex((prev) => (prev - 1 + productImages.length) % productImages.length);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isLightboxOpen]);

  // Prevent body scroll when lightbox is open
  useEffect(() => {
    if (isLightboxOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isLightboxOpen]);

  const openLightbox = (index) => {
    setLightboxImageIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  const goToNextImage = () => {
    setLightboxImageIndex((prev) => (prev + 1) % productImages.length);
  };

  const goToPrevImage = () => {
    setLightboxImageIndex((prev) => (prev - 1 + productImages.length) % productImages.length);
  };

  // Carton pricing options (10 cups per carton)
  const pricingOptions = [
    { cups: 'sample', cartons: 0, price: 0, label: 'Sample', description: 'Free sample' },
    { cups: 10, cartons: 1, price: 10, label: '10 cups', description: '1 carton' },
    { cups: 20, cartons: 2, price: 19.5, label: '20 cups', description: '2 cartons' },
    { cups: 30, cartons: 3, price: 28.50, label: '30 cups', description: '3 cartons' },
    { cups: 40, cartons: 4, price: 37, label: '40 cups', description: '4 cartons' },
    { cups: 50, cartons: 5, price: 46, label: '50 cups', description: '5 cartons' },
    { cups: 60, cartons: 6, price: 55, label: '60 cups', description: '6 cartons' },
    { cups: 70, cartons: 7, price: 64, label: '70 cups', description: '7 cartons' },
    { cups: 80, cartons: 8, price: 73, label: '80 cups', description: '8 cartons' },
    { cups: 90, cartons: 9, price: 82, label: '90 cups', description: '9 cartons' },
    { cups: 100, cartons: 10, price: 91, label: '100 cups', description: '10 cartons' },
    { cups: 120, cartons: 12, price: 108, label: '120 cups', description: '12 cartons' },
    { cups: 140, cartons: 14, price: 125, label: '140 cups', description: '14 cartons' },
    { cups: 160, cartons: 16, price: 142, label: '160 cups', description: '16 cartons' },
    { cups: 180, cartons: 18, price: 158, label: '180 cups', description: '18 cartons' },
    { cups: 200, cartons: 20, price: 175, label: '200 cups', description: '20 cartons' }
  ];

  const getSelectedPricing = () => {
    return pricingOptions.find(opt => String(opt.cups) === selectedQuantity) || pricingOptions[1];
  };

  const selectedPricing = getSelectedPricing();

  // Product images gallery - 110ml specific (new images)
  const productImages = [
    
	{ 
      id: 0, 
      src: cupffee_110ml, 
      alt: "Edible DRINKING CUP 110ml - Main Product View" 
    },
	
	{ 
      id: 1, 
      src: cup110_1, 
      alt: "Edible DRINKING CUP 110ml - Main Product View" 
    },
    { 
      id: 2, 
      src: cup110_2, 
      alt: "Edible DRINKING CUP 110ml - Espresso Making" 
    },
    { 
      id: 3, 
      src: cup110_3, 
      alt: "Edible DRINKING CUP 110ml - Product Display" 
    },
    { 
      id: 4, 
      src: cup110_4, 
      alt: "Edible DRINKING CUP 110ml - In Use" 
    },
    { 
      id: 5, 
      src: cup110_label, 
      alt: "Edible CUP 110ml - Product Label" 
    },
    { 
      id: 6, 
      src: cup110_nutrition, 
      alt: "Edible CUP 110ml - Nutrition Facts" 
    }
  ];

  // 110ml Product specific details
  const product = {
    name: "Edible CUP | 110 ml",
    subtitle: "The Perfect Espresso & Shot Size",
    stock: "SOLD OUT",
    sku: "CUP-110-ESP",
    cupsPerCarton: 10
  };

  // Key features specific to 110ml
  const keyFeatures = [
    "110ml capacity - perfect for espresso & small drinks",
    "Sold in cartons of 10 cups",
    "100% Edible & Vegan",
    "Heat resistant up to 85°C",
    "Leak-proof for 40+ minutes",
  ];

  // Product details specific to 110ml
  const productDetails = {
    dimensions: {
      height: "6 cm",
      topDiameter: "6.5 cm",
      bottomDiameter: "4.8 cm",
      weight: "14g",
      capacity: "110 ml"
    },
    ingredients: [
      "Wheat flour",
      "Oat bran",
      "Sugar",
      "Refined cocnout oil",
      "Stabilizers",
      "Sodium alginate (E401)",
      "Xanthan gum (E415)",
	  "Enzyme PreventASe"
    ],
    nutritionalInfo: {
      calories: "56 kcal",
      protein: "0.6g",
      carbohydrates: "10.9g",
      fat: "0.4g",
      Sugars: "1.8g"
    },
    storage: "Store in a cool, dry place (15-25°C) away from direct sunlight. Keep in original packaging until use. Best consumed within 12 months of production date. Once opened, use within 5 days.",
    certifications: ["FSSC 22000", "Vegan Certified", "Halal Certified", "FDA Approved"],
    shelfLife: "12 months from production date"
  };

  // FAQ specific to 110ml
  const faqs = [
    {
      question: "What is the 110ml cup best used for?",
      answer: "The 110ml Edible CUP is specifically designed for espresso shots, ristretto, macchiato, and small beverages. It's also perfect for tasting portions, sample drinks, and shot-sized servings."
    },
    {
      question: "How long can I keep my espresso in the 110ml cup?",
      answer: "The 110ml cup is designed to hold hot espresso (up to 85°C) for 40 minutes without leaking. Since espresso is typically consumed quickly, this provides more than enough time."
    },
    {
      question: "Will the cup fit under my espresso machine?",
      answer: "Yes! The 110ml cup is specifically designed to fit under standard espresso machine group heads. With a height of just 6cm, it fits perfectly under most commercial and home espresso machines."
    },
    {
      question: "Can I use the 110ml cup for cold drinks?",
      answer: "Absolutely! The 110ml cup works great for cold espresso shots, liqueur tastings, cold brew samples, and any small cold beverage. It maintains integrity even longer with cold drinks."
    }
  ];

  // Calculate price per cup for display
  const pricePerCup = selectedPricing.cups === 'sample' ? 0 : (selectedPricing.price / selectedPricing.cups).toFixed(2);

  return (
    <div className="edible-cup-page">
      {/* Breadcrumb Navigation */}
      <nav className="breadcrumb-nav">
        <div className="container">
          <ol className="breadcrumb">
            <li><Link to="/">Home</Link></li>
            <ChevronRight size={14} />
            <li><Link to="/edible-cups">Edible Cups</Link></li>
            <ChevronRight size={14} />
            <li className="current">Edible CUP | 110 ml</li>
          </ol>
        </div>
      </nav>

      {/* Main Product Section */}
      <section className="product-main-section">
        <div className="container">
          <div className="product-layout">
            {/* Image Gallery */}
            <div className="product-gallery">
              <div className="main-image-container" onClick={() => openLightbox(selectedImage)}>
                <span className="zoom-hint">
                  <ZoomIn size={20} />
                  Click to zoom
                </span>
                <img 
                  src={productImages[selectedImage].src} 
                  alt={productImages[selectedImage].alt}
                  className="main-product-image clickable"
                />
              </div>
              <div className="thumbnail-gallery">
                {productImages.map((img, index) => (
                  <button
                    key={img.id}
                    className={`thumbnail-btn ${selectedImage === index ? 'active' : ''}`}
                    onClick={() => setSelectedImage(index)}
                    onDoubleClick={() => openLightbox(index)}
                  >
                    <img src={img.src} alt={img.alt} />
                  </button>
                ))}
              </div>
            </div>

            {/* Product Info */}
            <div className="product-info">
              <span className="product-sku">SKU: {product.sku}</span>
              <h1 className="product-title">{product.name}</h1>
              <p className="product-subtitle">{product.subtitle}</p>

              {/* Price Display - Carton Based */}
              <div className="carton-pricing">
                {selectedPricing.cups === 'sample' ? (
                  <div className="price-main">
                    <span className="price free">FREE</span>
                    <span className="price-label">Sample</span>
                  </div>
                ) : (
                  <>
                    <div className="price-main">
                      <span className="price">€{selectedPricing.price.toFixed(2)}</span>
                      <span className="price-label">for {selectedPricing.cups} cups ({selectedPricing.cartons} {selectedPricing.cartons === 1 ? 'carton' : 'cartons'})</span>
                    </div>
                  </>
                )}
                <div className={`stock-status ${product.stock === "SOLD OUT" ? 'sold-out' : ''}`}>
                  <Check size={26} />
                  {product.stock}
                </div>
              </div>

              {/* Carton Info */}
              <div className="carton-info-box">
                <Package size={20} />
                <div>
                  <strong>Sold by Carton</strong>
                  <span>Each carton contains {product.cupsPerCarton} cups</span>
                </div>
              </div>

              {/* Size Info */}
              <div className="size-info-box">
                <Package size={20} />
                <div>
                  <strong>110 ml Espresso Size</strong>
                  <span>Perfect for espresso, ristretto & small drinks</span>
                </div>
              </div>

              {/* Quantity Selector - Dropdown */}
              <div className="purchase-controls-carton">
                <div className="quantity-dropdown-container">
                  <label>Select Quantity:</label>
                  <div className="quantity-dropdown">
                    <button 
                      className="quantity-dropdown-trigger"
                      onClick={() => setIsQuantityDropdownOpen(!isQuantityDropdownOpen)}
                    >
                      <span>
                        {selectedPricing.cups === 'sample' ? (
                          <>
                            <Gift size={16} />
                            Sample - FREE
                          </>
                        ) : (
                          <>
                            {selectedPricing.cups} cups ({selectedPricing.cartons} {selectedPricing.cartons === 1 ? 'carton' : 'cartons'}) - €{selectedPricing.price.toFixed(2)}
                          </>
                        )}
                      </span>
                      <ChevronDown size={18} className={isQuantityDropdownOpen ? 'rotate' : ''} />
                    </button>
                    
                    {isQuantityDropdownOpen && (
                      <div className="quantity-dropdown-menu">
                        {pricingOptions.map((option) => (
                          <button
                            key={option.cups}
                            className={`quantity-option ${String(option.cups) === selectedQuantity ? 'active' : ''}`}
                            onClick={() => {
                              setSelectedQuantity(String(option.cups));
                              setIsQuantityDropdownOpen(false);
                            }}
                          >
                            <div className="option-main">
                              {option.cups === 'sample' ? (
                                <>
                                  <Gift size={16} />
                                  <span className="option-cups">Sample</span>
                                </>
                              ) : (
                                <>
                                  <span className="option-cups">{option.cups} cups</span>
                                  <span className="option-cartons">({option.cartons} {option.cartons === 1 ? 'carton' : 'cartons'})</span>
                                </>
                              )}
                            </div>
                            <div className="option-price">
                              {option.cups === 'sample' ? (
                                <span className="free-tag">FREE</span>
                              ) : (
                                <>€{option.price.toFixed(2)}</>
                              )}
                            </div>
                            {String(option.cups) === selectedQuantity && <Check size={16} className="check-icon" />}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <button 
                  className={`add-to-cart-btn ${isAddedToCart ? 'added' : ''}`}
                  onClick={() => {
                    if (selectedPricing.cups === 'sample') {
                      // For samples, redirect to contact
                      window.location.href = '/contact';
                      return;
                    }
                    
                    const cartItem = {
                      id: 'edible-cup-110',
                      name: 'Edible CUP | 110 ml',
                      variant: `${selectedPricing.cups} cups (${selectedPricing.cartons} ${selectedPricing.cartons === 1 ? 'carton' : 'cartons'})`,
                      price: selectedPricing.price,
                      cartons: selectedPricing.cartons,
                      cups: selectedPricing.cups,
                      quantity: 1,
                      image: productImages[0].src
                    };
                    
                    addToCart(cartItem);
                    setIsAddedToCart(true);
                    
                    // Reset button after 2 seconds
                    setTimeout(() => {
                      setIsAddedToCart(false);
                    }, 2000);
                  }}
                >
                  {isAddedToCart ? (
                    <>
                      <Check size={20} />
                      Added to Cart!
                    </>
                  ) : (
                    <>
                      <ShoppingCart size={20} />
                      {selectedPricing.cups === 'sample' ? (
                        'Request Free Sample'
                      ) : (
                        `Add to Cart - €${selectedPricing.price.toFixed(2)}`
                      )}
                    </>
                  )}
                </button>
              </div>

              {/* Key Features */}
              <div className="key-features">
                <h3>Key Features</h3>
                <ul>
                  {keyFeatures.map((feature, index) => (
                    <li key={index}>
                      <Leaf size={16} className="feature-icon" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tabbed Content Section */}
      <section className="product-tabs-section">
        <div className="container">
          <div className="tabs-navigation">
            <button 
              className={`tab-btn ${activeTab === 'description' ? 'active' : ''}`}
              onClick={() => setActiveTab('description')}
            >
              Description
            </button>
            <button 
              className={`tab-btn ${activeTab === 'details' ? 'active' : ''}`}
              onClick={() => setActiveTab('details')}
            >
              Product Details
            </button>
            <button 
              className={`tab-btn ${activeTab === 'faq' ? 'active' : ''}`}
              onClick={() => setActiveTab('faq')}
            >
              FAQ
            </button>
          </div>

          <div className="tab-content">
            {/* Description Tab */}
            {activeTab === 'description' && (
              <div className="tab-panel description-panel">
                <h2>Edible Cupffee CUP | 110 ml - The Espresso Specialist</h2>
                <p>
                 The 110 ml Edible Cupffee Cup is our most compact option, created for espresso-focused service and shot-sized drinks.
                </p>
                <p>
                  Sized at 110 ml, it’s ideal for single and double espresso, ristretto, macchiato, and cortado. With a height of just 6 cm, it fits easily under nearly any espresso machine, from professional café setups to home machines.
                </p>
                <p>
                  Made from 100% natural ingredients, the cup is fully edible. Drink your coffee, then eat the cup for a true zero-waste experience. At just 14 g, it’s lighter and easier to enjoy after your drink.
                </p>
                
                <div className="description-features">
                  <div className="desc-feature">
                    <Package size={32} />
                    <h4>Espresso-Optimized Size</h4>
                    <p>6 cm height fits under any espresso machine. Perfect for single and double shots.</p>
                  </div>
                  <div className="desc-feature">
                    <Droplet size={32} />
                    <h4>The cup remains crunchy for up to 40 minutes!</h4>
                    <p>More than enough time for espresso. Most shots are enjoyed in under 5 minutes.</p>
                  </div>
                  <div className="desc-feature">
                    <Leaf size={32} />
                    <h4>Very high-quality feel and look</h4>
                    <p>Smooth to the touch, visually refined, and designed to feel substantial.</p>
                  </div>
                </div>
              </div>
            )}

            {/* Product Details Tab */}
            {activeTab === 'details' && (
              <div className="tab-panel details-panel">
                <div className="details-grid">
                  <div className="detail-section">
                    <h3><Package size={20} /> Dimensions</h3>
                    <table className="details-table">
                      <tbody>
                        <tr><td>Capacity</td><td>{productDetails.dimensions.capacity}</td></tr>
                        <tr><td>Height</td><td>{productDetails.dimensions.height}</td></tr>
                        <tr><td>Top Diameter</td><td>{productDetails.dimensions.topDiameter}</td></tr>
                        <tr><td>Bottom Diameter</td><td>{productDetails.dimensions.bottomDiameter}</td></tr>
                        <tr><td>Weight</td><td>{productDetails.dimensions.weight}</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="detail-section">
                    <h3><Leaf size={20} /> Ingredients</h3>
                    <ul className="ingredients-list">
                      {productDetails.ingredients.map((ingredient, index) => (
                        <li key={index}>{ingredient}</li>
                      ))}
                    </ul>
                    <p className="allergen-warning">
                      <strong>Allergen Information:</strong> Contains wheat and gluten.
                    </p>
                  </div>

                  <div className="detail-section">
                    <h3><Award size={20} /> Nutritional Information (per cup)</h3>
                    <table className="details-table">
                      <tbody>
                        <tr><td>Energy</td><td>{productDetails.nutritionalInfo.calories}</td></tr>
                        <tr><td>Protein</td><td>{productDetails.nutritionalInfo.protein}</td></tr>
                        <tr><td>Carbohydrates</td><td>{productDetails.nutritionalInfo.carbohydrates}</td></tr>
                        <tr><td>Fat</td><td>{productDetails.nutritionalInfo.fat}</td></tr>
                        <tr><td>Sugars</td><td>{productDetails.nutritionalInfo.Sugars}</td></tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="detail-section">
                    <h3><Clock size={20} /> Storage & Shelf Life</h3>
                    <p>{productDetails.storage}</p>
                    <p><strong>Shelf Life:</strong> {productDetails.shelfLife}</p>
                  </div>

                  <div className="detail-section full-width">
                    <h3><Award size={20} /> Certifications</h3>
                    <div className="certifications-list">
                      {productDetails.certifications.map((cert, index) => (
                        <span key={index} className="cert-badge">{cert}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* FAQ Tab */}
            {activeTab === 'faq' && (
              <div className="tab-panel faq-panel">
                <h2>Frequently Asked Questions - 110ml Cup</h2>
                <div className="faq-list">
                  {faqs.map((faq, index) => (
                    <div 
                      key={index} 
                      className={`faq-item ${expandedFaq === index ? 'expanded' : ''}`}
                    >
                      <button 
                        className="faq-question"
                        onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                      >
                        <span>{faq.question}</span>
                        {expandedFaq === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                      </button>
                      {expandedFaq === index && (
                        <div className="faq-answer">
                          <p>{faq.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Image Lightbox Modal */}
      {isLightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>
              <X size={28} />
            </button>
            
            <button className="lightbox-nav lightbox-prev" onClick={goToPrevImage}>
              <ChevronLeft size={36} />
            </button>
            
            <div className="lightbox-image-container">
              <img 
                src={productImages[lightboxImageIndex].src} 
                alt={productImages[lightboxImageIndex].alt}
                className="lightbox-image"
              />
            </div>
            
            <button className="lightbox-nav lightbox-next" onClick={goToNextImage}>
              <ChevronRight size={36} />
            </button>
            
            <div className="lightbox-thumbnails">
              {productImages.map((img, index) => (
                <button
                  key={img.id}
                  className={`lightbox-thumb ${lightboxImageIndex === index ? 'active' : ''}`}
                  onClick={() => setLightboxImageIndex(index)}
                >
                  <img src={img.src} alt={img.alt} />
                </button>
              ))}
            </div>
            
            <div className="lightbox-counter">
              {lightboxImageIndex + 1} / {productImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EdibleCup110;
